import {Component, OnInit, OnDestroy, Input, Output, EventEmitter} from '@angular/core';
import * as globals from '../settings';
import {LotteriesService} from '../lotteries.service';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {SubscriptionsService} from '../_services/subscriptions.service';
import {Subscription} from 'rxjs';
import {CurrencyService} from '../_services/currency.service';
import {JackpotConfigService} from '../_services/jackpotConfig.service';
import {ScratchService} from '../scratch/scratch.service';

interface PackageDetails {
  PackageID: string
  Name: string
  DisplayName: string
  box: any;
  BackgroundColor: string;
  Draws: number;
  Duration: number;
  TotalSingleLines: number;
  TotalTeamplayLines: number;
  DisplayNames: string;
  IconName: string;
  TotalSingleDraws: number;
  TotalTeamplayDraws: number;
  Rates: {
    OnlinePrice: string
  }
}

@Component({
  selector: 'package-details-popup',
  templateUrl: './package-details-popup.component.html',
  styleUrls: ['./package-details-popup.component.scss']
})
export class PackageDetailsPopupComponent implements OnInit, OnDestroy {
  @Input() item: PackageDetails;
  desktop: number;
  screenWidth: number;
  isMobile: boolean;
  languageChange: Subscription;
  showLang: string;
  @Input() showDetails: boolean = true;
  isLoadingButton: boolean;
  isSafari: boolean;
  isTablet: boolean;
  toggleContent: boolean;
  toggleContentSubscription: Subscription;
  changedCurrency: Subscription;
  currency: any;
  afterComma = globals.afterComma;
  brand = globals.brand;
  buyPackageSubscription: Subscription;
  @Output() onVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(public lotteryService: LotteriesService,
              public subscriptionsService: SubscriptionsService,
              private router: Router, private translate: TranslateService,
              public currencyService: CurrencyService,
              public jackpotConfig: JackpotConfigService,
              private scratchService: ScratchService) {
    this.showLang = localStorage.getItem('pageLanguage');
    this.toggleContentSubscription = this.subscriptionsService.getToggleContent().subscribe(data => {
      if (this.lotteryService.isMobile) {
        if (this.toggleContent !== data) {
          this.toggleContent = data;
        }
      }
    });
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= 481) {
      this.desktop = 1;
    } else if (this.screenWidth <= 767) {
      this.desktop = 2;
    } else if (this.screenWidth <= 992) {
      this.desktop = 2;
    } else if (this.screenWidth <= 1200) {
      this.desktop = 3;
    } else {
      this.desktop = 3;
    }
    if (this.screenWidth <= 1023) {
      this.isTablet = true;
    }
    this.languageChange = this.subscriptionsService.getLanguage().subscribe(lang => {
      this.showLang = lang;
    });

    this.currency = this.currencyService.currency;
    this.changedCurrency = this.subscriptionsService.getChangeCurrency().subscribe(currency => {
      if (currency) {
        this.currency = currency;
      }
    });
  }

  ngOnDestroy() {
    if (this.changedCurrency) {
      this.changedCurrency.unsubscribe();
    }
    if (this.buyPackageSubscription) {
      this.buyPackageSubscription.unsubscribe();
    }
  }

  getLang() {
    const language = localStorage.getItem('pageLanguage');
    if (language !== null) {
      this.translate.use(language);
    } else {
      setTimeout(() => {
        this.getLang();
      }, 500);
    }
  }

  moreInfo(item) {
    this.item = item;
    this.subscriptionsService.emitToggleContent(false);
  }

  updateCartLength(): void {
    let cart = localStorage.getItem('cart');
    cart = JSON.parse(cart);
    if (cart.length > 0) {
      this.subscriptionsService.updateCart(cart.length);
      this.router.navigate(['/' + this.showLang, 'cart']);
    }
  }

  buyPackage(id) {
    this.isLoadingButton = true;
    this.scratchService.buyPackage(id).then(() => {
      this.isLoadingButton = false;
      this.updateCartLength();
    });
  }

  ngOnInit() {
    this.toggleContent = true;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= 1023) {
      this.isTablet = true;
    }
    this.isLoadingButton = false;
    this.isSafari = false;
    const ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') !== -1) {
      if (ua.indexOf('chrome') === -1) {
        this.isSafari = true;
      }
    }
  }

  changeVisibility() {
    this.onVisibleChange.emit(this.showDetails);
  }

}
